module.exports = __webpack_public_path__ + "img/Date.0f1e2cd7.svg";